import React, { useEffect, useState, useRef } from "react";
import Card from "../../components/ConfigurationCards";
import Paper from "@material-ui/core/Paper";
import {
  CardsWrapper,
  ContentFilters,
  useStyles,
} from "./SpaceManagerTabs.styled";
import { Col, Row } from "react-bootstrap";
import GeneralFiltersContainer from "../../containers/GeneralFiltersContainer/GeneralFiltersContainer";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import SearchComponent from "../SearchComponent/SearchComponent";

const SpaceManagerTabs = ({
  selectedMenu,
  setFormTrigger,
  selectMenu,
  setValueTabs,
  valueTabs,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();
  const [filtered, setFiltered] = useState(false);
  const [dataFilter, setDataFilter] = useState({});
  const filtersViews = {
    countries: true,
    cities: true,
    search: {
      show: false,
      label: "Search by name",
    },
  };

  const [searchText, setSearchText] = useState();
  const rSearch = useRef();

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    filterMySpaces();
  }, [searchText]);

  useEffect(() => {
    if (!filtered) {
      handleChangeRowsPerPage({ target: { value: null } }, {});
    }
  }, [filtered]);

  let filterMySpaces = () => {
    setFiltered(true);
    handleChangeRowsPerPage(
      { target: { value: null } },
      { ...dataFilter, name: searchText }
    );
  };

  let goToYammer = () => {
    selectMenu(["yammer", "Yammer"]);
    setValueTabs(1);
  };

  let goToMySpace = () => {
    selectMenu(["myspaces", "My Spaces"]);
    setValueTabs(0);
  };

  let showSelectedTab = (selected) => {
    if (selected === "myspaces") {
      return (
        <Card
          iconplusactive={true}
          coloricon="#FFFFFF"
          colorBorder="#FFFFFF"
          icon="Person"
          code="myspace"
          title="Add Space"
          subtitle="space creation"
          footerText="Create new Space now"
          setFormTrigger={setFormTrigger}
        />
      );
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Paper position="static">
          <AntTabs aria-label="Spaces Management" value={valueTabs}>
            <AntTab
              label="My Spaces"
              id="myspaces"
              onClick={() => goToMySpace()}
            />
            <AntTab label="Yammer" id="yammer" onClick={() => goToYammer()} />
          </AntTabs>
        </Paper>
        <Row>
          <Col md={3}>
            <CardsWrapper className="pt-3 pb-2">
              {showSelectedTab(selectedMenu[0])}
            </CardsWrapper>
          </Col>
          {selectedMenu[0] === "myspaces" && (
            <Col md={9}>
              <ContentFilters
                style={{ marginLeft: "3em" }}
                className={"mr-0 mb-3"}
              >
                <GeneralFiltersContainer
                  filtersViews={filtersViews}
                  FilterEvents={filterMySpaces}
                  setDataFilter={setDataFilter}
                  filtered={filtered}
                  setFiltered={setFiltered}
                />
                <SearchComponent
                  rSearch={rSearch}
                  handleSearch={handleSearch}
                  setSearchText={setSearchText}
                />
              </ContentFilters>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default SpaceManagerTabs;
